async function getColorUpdate(clickedElement) {
  try {
    const url = clickedElement.getAttribute("data-url");
    if (!url) {
      console.error("No data-url found on clicked element.");
      return;
    }

    const oldCard = clickedElement.closest(".product-card-wrapper");
    const oldStarWidget = oldCard.querySelector(".jdgm-widget");
    const clonedStarWidget = oldStarWidget ? oldStarWidget.cloneNode(true) : null;

    const response = await fetch(url);
    if (!response.ok) {
      console.error("Failed to load URL:", url);
      return;
    }

    const htmlText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");

    const hiddenCard = doc.querySelector("#hidden__card");
    if (!hiddenCard) {
      console.error("Could not find #hidden__card in fetched HTML.");
      return;
    }

    const newCardHTML = hiddenCard.querySelector(".product-card-wrapper");
    if (!newCardHTML) {
      console.error("Could not find .product-card-wrapper inside #hidden__card.");
      return;
    }

    // Replace current card's content
    oldCard.innerHTML = newCardHTML.innerHTML;

    // Reinsert cloned star rating widget if it exists
    if (clonedStarWidget) {
      const newStarWrapper = oldCard.querySelector(".jdgm-widget");
      if (newStarWrapper) {
        newStarWrapper.replaceWith(clonedStarWidget);
      }
    }

  } catch (error) {
    console.error("An error occurred in getColorUpdate():", error);
  }
}
